import { render, staticRenderFns } from "./AddPropertyLandlord.vue?vue&type=template&id=094f490e&scoped=true"
import script from "./AddPropertyLandlord.vue?vue&type=script&lang=js"
export * from "./AddPropertyLandlord.vue?vue&type=script&lang=js"
import style0 from "./AddPropertyLandlord.vue?vue&type=style&index=0&id=094f490e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094f490e",
  null
  
)

export default component.exports